import {makeAutoObservable} from 'mobx';
import {LoginReq, UserLoginStoreInterface} from "./interface";
import {postRequest} from "utils/axios";
import {DEFAULT_BUSINESS_ID, PAI_POINT_AUTH, REQUEST_API_CODE_ENUM} from "utils/constants";
import {GET_USER_INFO_URL, LOGIN_URL} from "utils/constantsApi";
import routerStore from "../RouterStore";

const defaultUserInfoStoreDate: UserLoginStoreInterface = {
    userInfo: {},
    fetchUserLoginLoading: false,
}
class Store {
    userInfo: any
    fetchUserLoginLoading: boolean
    constructor(userInfoStore: UserLoginStoreInterface) {
        makeAutoObservable(
            this,
            {

            },
            {
                autoBind:true
            }
        );
        this.userInfo = userInfoStore.userInfo
        this.fetchUserLoginLoading = userInfoStore.fetchUserLoginLoading
    }

    async fetchUserLogin(req: LoginReq) {
        this.fetchUserLoginLoading = true
        try {
            const res = await postRequest(LOGIN_URL, req)
            if (res?.code === REQUEST_API_CODE_ENUM.SUCCESS) {
                localStorage.setItem(PAI_POINT_AUTH, res?.data?.code);
                const userInfo = await this.getUserInfo()
                if (userInfo.code === REQUEST_API_CODE_ENUM.SUCCESS) {
                    this.userInfo = userInfo?.data;
                    routerStore.setPath(`/${DEFAULT_BUSINESS_ID}/admin/index`)
                }
            }
            this.fetchUserLoginLoading = false
            return res
        } catch (e) {
            this.fetchUserLoginLoading = false
            return e
        }
    }

    async getUserInfo() {
        return await postRequest(GET_USER_INFO_URL, {});
    }

}

const UserInfoStore: Store = new Store(defaultUserInfoStoreDate);

export default UserInfoStore;